import Cookies from "universal-cookie";
import { LOCAL_STORAGE_KEY } from "src/constants";
import { domainName, dateExpires } from "src/config";

const cookies = new Cookies();

export const GetDataFromStorage = key => {
  // try {
  //   const _data = localStorage.getItem(key);
  //   return _data;
  // } catch (error) {
  //   console.error(error);
  // }
  return cookies.get(key);
};

export const SetDataToStorage = (key, value) => {
  // try {
  //   localStorage.setItem(key, value);
  // } catch (error) {
  //   console.error(error);
  // }
  cookies.set(key, value, {
    path: "/",
    domain: domainName,
    expires: dateExpires
  });
};

export const ClearStorage = () => {
  for (let key in LOCAL_STORAGE_KEY) {
    cookies.remove(LOCAL_STORAGE_KEY[key], { path: "/", domain: domainName });
  }
  // localStorage.clear();
};
